/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Card from '../../components/card/Card';
import Footer from '../../components/footer/Footer';
import Loader from '../../components/loader/Loader';
import NavBarNew from '../../components/navBarNew/NavBarNew';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  getProductsByCategories,
  getFilters,
  ordenarProductos
} from '../../utils/products/products';
import { Toaster, toast } from 'react-hot-toast';
import axios from 'axios';
import {
  Box,
  Typography,
  Grid
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@react-hook/media-query';
import OrdenarDropdown from '../../components/ordenarDropdown/OrdenarDropdown';
import MegaMenuMobile from '../../components/megaMenu/MegaMenuMobile';
// import ShareButton from './ShareButton';

import './NewCatalogue.Module.css';

function NewCatalogue() {
  const token = localStorage.getItem('Token');
  const config = { headers: { xtoken: `${token}` } };
  const user = useSelector((state) => state.user.userInfo);
  const isSuperAdmin = user.role === 'SUPERADMIN_ROLE';

  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useMediaQuery('(max-width: 768px)');

  // Badges / marcas de agua
  const [saleImage, setSaleImage] = React.useState('');
  const [marcaSection1, setMarcaSection1] = React.useState('');
  const [marcaSection2, setMarcaSection2] = React.useState('');
  const [marcaSection3, setMarcaSection3] = React.useState('');

  React.useEffect(() => {
    const fetch1 = async () => {
      const { data } = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=IMPERDIBLES_HOME`);
      setMarcaSection2(data.imagenes[0]?.marcaAgua);
    };
    fetch1();
  }, []);
  React.useEffect(() => {
    const fetch2 = async () => {
      const { data } = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=GANGA_SECTION`);
      setMarcaSection1(data.imagenes[0]?.marcaAgua);
    };
    fetch2();
  }, []);
  React.useEffect(() => {
    const fetch3 = async () => {
      const { data } = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=MINI_HOME`);
      setMarcaSection3(data.imagenes[0]?.marcaAgua);
    };
    fetch3();
  }, []);
  React.useEffect(() => {
    const fetch4 = async () => {
      const { data } = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=GANGA_SECTION`);
      setSaleImage(data.imagenes[0]?.url);
    };
    fetch4();
  }, []);

  // --------------------------
  // Carga única de productos
  // --------------------------
  const [allProducts, setAllProducts] = React.useState([]); // todos los productos del catálogo
  const [loader, setLoader] = React.useState(false);
  const [filtros, setFiltros] = React.useState(null);

  const LIMIT_TODO = 5000; // algo holgado

  React.useEffect(() => {
    toast.remove();
    window.scrollTo(0, 0);
    (async () => {
      try {
        setLoader(true);
        const filtros = await getFilters(id);
        setFiltros(filtros);

        // carga única de productos
        const res = await getProductsByCategories(id, 0, {}, LIMIT_TODO);
        setAllProducts(res?.productos || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoader(false);
      }
    })();
  }, [id]);

  // --------------------------
  // Helpers URL
  // --------------------------
  const updateURL = React.useCallback((patch) => {
    const sp = new URLSearchParams(searchParams.toString());
    Object.entries(patch).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') sp.delete(k);
      else sp.set(k, String(v));
    });
    setSearchParams(sp, { replace: true });
  }, [searchParams, setSearchParams]);

  // Campo de búsqueda controlado
  const [termino, setTermino] = React.useState(searchParams.get('q') || '');
  React.useEffect(() => {
    setTermino(searchParams.get('q') || '');
  }, [searchParams]);

  // búsqueda live a partir de 3 letras, limpiar si vacío
  const handleSearch = (e) => {
    const val = e.target.value;
    setTermino(val);

    if (val === '') {
      updateURL({ q: undefined });
    } else if (val.length >= 3) {
      updateURL({ q: val });
    }
  };

  // con Enter aplicar siempre (aunque tenga 1 o 2 chars)
  const handleSearchTerm = () => {
    updateURL({ q: termino || undefined });
  };

  const toggleVegan = () => {
    const next = searchParams.get('vegan') === '1' ? undefined : '1';
    updateURL({ vegan: next });
  };
  const handleMarcaChange = (marca) => updateURL({ marca: marca || undefined });
  const removeTag = () => updateURL({ cat: undefined });
  const removeTag2 = () => updateURL({ subcat: undefined });

  // helpers para mensaje vacío
  const clearAllFilters = () => {
    const sp = new URLSearchParams(searchParams.toString());
    ['q', 'marca', 'cat', 'subcat', 'vegan'].forEach(k => sp.delete(k));
    setSearchParams(sp, { replace: true });
  };
  const hasActiveFilters =
    !!(searchParams.get('q') ||
       searchParams.get('marca') ||
       searchParams.get('cat') ||
       searchParams.get('subcat') ||
       searchParams.get('vegan') === '1');

  // --------------------------
  // Filtrado + orden en el cliente
  // --------------------------
  const [tipoOrdenamiento, setTipoOrdenamiento] = React.useState('');

  const normalize = (s = '') =>
    String(s).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');

  const includesText = (text, needle) =>
    normalize(text).includes(normalize(needle));

  const equalsText = (a, b) => normalize(a) === normalize(b);

  const displayProducts = React.useMemo(() => {
    let list = [...allProducts];
    if (!list.length) return list;

    const q = searchParams.get('q') || '';
    const marca = searchParams.get('marca') || '';
    const cat = searchParams.get('cat') || '';
    const subcat = searchParams.get('subcat') || '';
    const vegan = searchParams.get('vegan') === '1';

    // Filtros
    if (vegan) list = list.filter(p => p?.vegan === true);
    if (marca) list = list.filter(p => equalsText(p?.marca || '', marca));
    if (cat) {
      list = list.filter(p =>
        equalsText(p?.categoria, cat) ||
        p?.categorias?.some?.((c) => equalsText(c, cat)) ||
        p?.tags?.some?.((t) => equalsText(t, cat)) ||
        p?.tags2?.some?.((t) => equalsText(t, cat))
      );
    }
    if (subcat) {
      list = list.filter(p =>
        equalsText(p?.subcategoria, subcat) ||
        p?.subcategorias?.some?.((s) => equalsText(s, subcat)) ||
        p?.tags2?.some?.((t) => equalsText(t, subcat))
      );
    }
    if (q) {
      list = list.filter(p =>
        includesText(p?.nombre || '', q) ||
        includesText(p?.descripcion || '', q) ||
        includesText(p?.marca || '', q)
      );
    }

    // Orden
    if (tipoOrdenamiento) {
      try {
        list = ordenarProductos(list, tipoOrdenamiento);
      } catch (e) {
        // si ordenarProductos esperaba otro shape, ignoramos
      }
    }

    return list;
  }, [allProducts, searchParams, tipoOrdenamiento]);

  const cambiarOrdenamiento = (tipo) => {
    setTipoOrdenamiento(tipo || '');
  };

  // --------------------------
  // Cloudinary (sin cambios)
  // --------------------------
  const [image, setImage] = React.useState('');
  const [renderKey, setRenderKey] = React.useState(0);
  function handleOpenWidget() {
    try {
      const widgetCloudinary = window.cloudinary.createUploadWidget(
        { cloudName: 'dlblszxyo', uploadPreset: 'laBeautiqueria' },
        async (err, result) => {
          if (!err && result && result.event === 'success') {
            const url = result.info.secure_url;
            await axios.put(
              `${process.env.REACT_APP_BACK_URL}/api/imagenes/${image._id}?url=${url}`,
              '',
              config
            );
            setImage({ ...image[0], url });
            setRenderKey((prevKey) => prevKey + 1);
          }
        }
      );
      widgetCloudinary.open();
    } catch (error) {
      toast.error('Problema con la carga de la imagen', error);
    }
  }

  return (
    <div className='fondoCatalogue' style={{ backgroundColor: 'white', paddingTop: !isMobile && '18vh' }}>
      <header className='headerCatalogue'>
        <NavBarNew isCatalogue={true} />
      </header>

      <main className='catalogueMain' style={{ paddingTop: isMobile && '18vh' }}>
        {isSuperAdmin && (
          <div className='fondoPrevButton' onClick={() => handleOpenWidget()}>
            <i className='bi bi-pencil'></i>
            cambiar fondo
          </div>
        )}

        {loader || filtros?.length === 0 ? (
          <Loader />
        ) : (
          <>
            <Toaster
              position='bottom-left'
              reverseOrder={false}
              toastOptions={{ className: 'fondoToast' }}
            />

            <div className='containerSearch' style={{ marginTop: isMobile && '-10vh', marginBottom: isMobile && '75px' }}>
              <Box sx={{ width: isMobile ? '90vw' : '55vw', paddingBottom: '1vh', marginBottom: '5px' , marginTop:"5px"}}>
                {/* <ShareButton /> */}
                <form
                  style={{ display: 'flex', alignItems: 'center' }}
                  className='form-group has-feedback'
                  role='search'
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSearchTerm();
                  }}
                >
                  <input
                    style={{ paddingLeft: '35px', borderRadius: '20px', fontFamily: 'Poppins' }}
                    className='form-control me-2'
                    type='search'
                    placeholder='Buscar'
                    value={termino}
                    onChange={handleSearch}
                  />
                  <i style={{ fontSize: '20px' }} className='bx bx-search form-control-feedback'></i>
                </form>
              </Box>

              {/* Chips de filtros activos (mobile) */}
              {isMobile &&
                (searchParams.get('vegan') === '1' ||
                  searchParams.get('marca') ||
                  searchParams.get('cat') ||
                  searchParams.get('subcat')) && (
                  <div>
                    <Typography style={{ fontFamily: 'Poppins', fontSize: isMobile ? '16px' : '14px', fontWeight: 600 }}>
                      Se muestra:
                    </Typography>
                    <ul style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      {searchParams.get('marca') && (
                        <li style={{ fontFamily: 'Poppins', minHeight: '35px', fontSize: '14px' }}>
                          Marca: <b>{searchParams.get('marca')}</b>
                          <i className='bi bi-x-circle filterOptionX' onClick={() => handleMarcaChange('')}></i>
                        </li>
                      )}
                      {searchParams.get('vegan') === '1' && (
                        <li style={{ fontFamily: 'Poppins', minHeight: '35px', fontSize: '14px' }}>
                          Productos Veganos
                          <i className='bi bi-x-circle filterOptionX' onClick={toggleVegan}></i>
                        </li>
                      )}
                      {searchParams.get('cat') && (
                        <li style={{ fontFamily: 'Poppins', minHeight: '35px', fontSize: '14px' }}>
                          Categoría: <b>{searchParams.get('cat')}</b>
                          <i className='bi bi-x-circle filterOptionX' onClick={removeTag}></i>
                        </li>
                      )}
                      {searchParams.get('subcat') && (
                        <li style={{ fontFamily: 'Poppins', minHeight: '35px', fontSize: '14px' }}>
                          Sub categoría: <b>{searchParams.get('subcat')}</b>
                          <i className='bi bi-x-circle filterOptionX' onClick={removeTag2}></i>
                        </li>
                      )}
                    </ul>
                  </div>
                )}
            </div>

            {/* Filtros activos (desktop fixed) */}
            {!isMobile &&
              (searchParams.get('vegan') === '1' ||
                searchParams.get('marca') ||
                searchParams.get('cat') ||
                searchParams.get('subcat')) && (
                <div style={{ position: 'fixed', left: 0, top: '15vh', zIndex: 3 }} className='selectedFilters'>
                  <Typography style={{ color: '#ffffff', fontFamily: 'Montserrat', fontSize: '14px' }}>
                    Se muestra:
                  </Typography>
                  <ul>
                    {searchParams.get('marca') && (
                      <li style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '12px' }}>
                        Marca: {searchParams.get('marca')}
                        <i className='bi bi-x-circle filterOptionX' onClick={() => handleMarcaChange('')}></i>
                      </li>
                    )}
                    {searchParams.get('vegan') === '1' && (
                      <li style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '12px' }}>
                        Productos Veganos
                        <i className='bi bi-x-circle filterOptionX' onClick={toggleVegan}></i>
                      </li>
                    )}
                    {searchParams.get('cat') && (
                      <li style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '12px' }}>
                        Categoría: {searchParams.get('cat')}
                        <i className='bi bi-x-circle filterOptionX' onClick={removeTag}></i>
                      </li>
                    )}
                    {searchParams.get('subcat') && (
                      <li style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '12px' }}>
                        Sub categoría: {searchParams.get('subcat')}
                        <i className='bi bi-x-circle filterOptionX' onClick={removeTag2}></i>
                      </li>
                    )}
                  </ul>
                </div>
              )}

            {/* Catálogo */}
            <div className='containerCatalogueAndFilter'>
              <div
                style={{ marginTop: !isMobile ? '25px' : '-5vh', paddingLeft: !isMobile ? '15%' : '3%' }}
                className='container containerCatalogue'
              >
                {displayProducts.length === 0 ? (
                  <div style={{ marginTop: !isMobile && '25px' }} className='divCatalogue px-2 py-2'>
                    <Typography style={{ fontFamily: 'Poppins', fontSize: isMobile ? '12px' : '14px' }}>
                      No se encontraron resultados
                      {searchParams.get('q') ? ` para "${searchParams.get('q')}"` : ''}
                      {hasActiveFilters && ' con los filtros seleccionados'}.{' '}
                      <span
                        onClick={clearAllFilters}
                        style={{ textDecoration: 'underline', cursor: 'pointer' }}
                      >
                        Limpiar filtros
                      </span>
                    </Typography>
                  </div>
                ) : (
                  <Grid container spacing={isMobile ? 1 : 3} justifyContent='center'>
                    {displayProducts.map((producto, index) => (
                      <Grid item xs={6} sm={6} md={4} key={index}>
                        <div className={`${!isMobile ? 'py-5' : 'py-2'} ${isMobile ? 'mobile-card' : ''}`}>
                          <Card
                            sale={producto}
                            isMobile={isMobile}
                            termino={termino}
                            saleImage={producto?.precioOferta ? marcaSection1 : ''}
                            marcaSection1={marcaSection1}
                            marcaSection2={marcaSection2}
                            marcaSection3={marcaSection3}
                          />
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </div>

              {!isMobile && (
                <div style={{ position: 'fixed', left: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ maxHeight: '80vh', overflowY: 'scroll' }} className='filterSection'>
                    <OrdenarDropdown cambiarOrdenamiento={cambiarOrdenamiento} />
                    <MegaMenuMobile />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </main>

      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default NewCatalogue;
